module.exports = __webpack_public_path__ + "assets/trim.cc90144d.svg";